// frontend/src/components/BreadcrumbsNav.jsx
import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useLocation, Link as RouterLink } from 'react-router-dom';

const BreadcrumbsNav = () => {
  const location = useLocation();

  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ my: 2 }}>
      <Link component={RouterLink} to="/" underline="hover" color="inherit">
        Home
      </Link>
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;

        // Jika terakhir, tampilkan Typography, jika tidak, tampilkan Link
        const isLast = index === pathnames.length - 1;
        const formattedValue = value
          .replace(/-/g, ' ')
          .replace(/\b\w/g, (char) => char.toUpperCase());

        return isLast ? (
          <Typography color="text.primary" key={to}>
            {formattedValue}
          </Typography>
        ) : (
          <Link component={RouterLink} to={to} key={to} underline="hover" color="inherit">
            {formattedValue}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbsNav;